{
  "en": {
    "survey": {
      "actions": {
        "add": "Add new",
        "addDescription": "Add description",
        "close": "Close",
        "create": "Create",
        "createNew": "New",
        "delete": "Delete",
        "deleteCount": "You are about to delete {count} survey. Are you sure? | You are about to delete {count} surveys. Are you sure?",
        "deleteMultiple": "Delete...",
        "delete_cancel": "Cancel",
        "delete_surveys": "Delete survey | Delete surveys",
        "importTemplate": "Import",
        "newSurvey": "Survey",
        "publish": "Publish",
        "publishCustomer": "Publish for customers",
        "revokeAccess": "Revoke access",
        "save": "Save",
        "selectAll": "Select all {total} surveys",
        "send": "Send",
        "sendCustomer": "Send to customer",
        "submit": "Submit",
        "surveys_collapse": "Collapse surveys",
        "surveys_expand": "Expand surveys",
        "unSelectAll": "Clear selection.",
        "unpublish": "Unpublish"
      },
      "attributes": {
        "description": "Internal title",
        "title": "Your question"
      },
      "labels": {
        "NPSOverview": "NPS Overview",
        "NPSQuestion": "How likely are you to recommend {name} to a friend or colleague?",
        "addQuestion": "Question",
        "allUnitsAssigned": "All units assigned",
        "answerRequired": "Answer (required)",
        "answer_later": "Answer later",
        "answeredAt": "Answered at",
        "average_score": "Average score",
        "clientTeam": "The {name} Team",
        "comments": "Comments or suggestions? (optional)",
        "completedTime": "Answered",
        "customer": "Customer",
        "customer_status": "Status",
        "detractors": "Detractors",
        "dissatisfied": "Dissatisfied",
        "extremelyLikely": "Extremely likely",
        "lets_go": "Let's go",
        "list": "List",
        "mostRecentAnswers": "Most recent answers",
        "neither_satisfied_nor_dissatisfied": "Neither satisfied nor dissatisfied",
        "neutrals": "Neutrals",
        "noAnswers": "No answers yet",
        "noSurveyFeedback": "No comments or suggestions",
        "noSurveysYet": "No surveys yet. Create your first survey to get started.",
        "noUnitsClick": "No units yet, click here to add",
        "no_opinion": "No opinion",
        "notAtAllLikely": "Not at all likely",
        "nps": "NPS",
        "numberAnswered": "{answered} out of {total} responses",
        "obligatory": "Make survey obligatory for customers",
        "pendingSurveys": " We need your feedback",
        "promoters": "Promoters",
        "publishNow?": "Publish now?",
        "published": "Published",
        "publishedCount": "Publish this survey to customer | Publish {count} surveys to customers",
        "question": "Question",
        "question_number": "Question {current_number} of {total_questions}",
        "questions": "Questions",
        "respondents": "No respondents | 1 respondent | {count} respondents",
        "response": "Response",
        "responseTime": "Response Time",
        "responses": "Responses",
        "revokeAccessCount": "Revoke access to this survey for customer | Revoke access to this survey for {count} customers",
        "satisfied": "Satisfied",
        "saveExplainer": "Make this survey visible for your customers? Or save and publish later?",
        "scoreBreakdown": "Score breakdown",
        "selectOneUnit": "Select at least 1 survey",
        "selectUnits": "Select units",
        "selected": "{selected} survey is selected. | {selected} surveys are selected.",
        "sendCount": "Send this survey to customer | Send surveys to {count} customers",
        "sendExplainer": "Your customers will see this on their dashboard",
        "sendNow?": "Send now?",
        "sent": "Sent",
        "sentCustomer": "Sent to customer",
        "showSurveysFor": "Show surveys for",
        "showingResultsFor": "Showing results for",
        "step0Title": "Which template project and survey do you want to use?",
        "step2Subtitle": "So your customers know what the purpose is of this survey",
        "step2Title": "Add a short introduction",
        "step3Subtitle": "Select your project to include all your units at once.",
        "step3Title": "For which units would you like to create this survey?",
        "survey": "Survey",
        "surveyAlreadyAnswered": "Survey has already been answered. Thank you for your feedback.",
        "surveyAnswer": "Feedback",
        "surveyNotCompleted": "Survey is not completed yet.",
        "surveys": "Surveys",
        "surveysCount": "{count} survey | {count} surveys",
        "surveys_all_projects": "Surveys all projects",
        "tabOverview": "Overview",
        "tabSurveys": "Surveys",
        "thankYou": "Thank you for your feedback!",
        "title": "Question",
        "titles_must_be_unique": "There are duplicate questions. Questions must be unique!",
        "totalSelected": "All {total} surveys are selected.",
        "unanswered": "Unanswered",
        "unit": "Unit",
        "unitSelected": "No unit selected yet | One unit selected | {count} units selected",
        "units": "Units",
        "unitsWithoutSurvey": "{count} unit without a survey | {count} units without a survey",
        "unpublishedCount": "Unpublish this survey | Unpublish {count} surveys",
        "very_dissatisfied": "Very dissatisfied",
        "very_satisfied": "Very satisfied",
        "visibility": "Visibility",
        "yourAnswers": "Your Answers",
        "yourQuestion": "Your Question"
      },
      "placeholders": {
        "employees": {
          "new": {
            "subtitle": "Ask your customers for feedback",
            "title": "Create your first Survey"
          },
          "none": {
            "subtitle": "Ask your customers for feedback",
            "title": "No surveys found"
          }
        }
      },
      "toasts": {
        "bulk_create": "Survey successfully created | Surveys successfully created",
        "bulk_delete": "Survey successfully deleted | Surveys successfully deleted",
        "bulk_update": "Survey successfully updated | Surveys successfully updated",
        "update": "Survey successfully updated"
      },
      "validation": {
        "needName": "Enter a question",
        "needQuestion": "Add at least 1 question",
        "selectUnit": "Select at least 1 unit"
      }
    }
  }
}